import { render, staticRenderFns } from "./QueenForm.vue?vue&type=template&id=ac30513c&scoped=true&"
import script from "./QueenForm.vue?vue&type=script&lang=js&"
export * from "./QueenForm.vue?vue&type=script&lang=js&"
import style0 from "./QueenForm.vue?vue&type=style&index=0&id=ac30513c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac30513c",
  null
  
)

export default component.exports